import { useState, useEffect } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Default values (fallback if API fails)
const DEFAULT_CONTENT = {
  contact_info: {
    company_name: 'Nessenius Garten & Landschaftsbau',
    owner: 'Lennard Nessenius',
    address: 'Alte Straße 17',
    zip_city: '37176 Nörten-Hardenberg',
    phone: '+49 176 55669090',
    email: 'nesseniusgartenservice@gmail.com',
    opening_hours: {
      mo_fr: '08:00 - 18:00',
      sa: '09:00 - 14:00',
      so: 'Geschlossen'
    }
  },
  impressum: {
    company_name: 'Nessenius Garten & Landschaftsbau',
    owner: 'Lennard Nessenius',
    address: 'Alte Straße 17',
    zip_city: '37176 Nörten-Hardenberg',
    phone: '+49 176 55669090',
    email: 'nesseniusgartenservice@gmail.com',
    tax_id: '',
    additional_info: ''
  },
  datenschutz: {
    company_name: 'Nessenius Garten & Landschaftsbau',
    owner: 'Lennard Nessenius',
    address: 'Alte Straße 17, 37176 Nörten-Hardenberg',
    email: 'nesseniusgartenservice@gmail.com',
    custom_text: ''
  }
};

export const useSiteContent = (key) => {
  const [content, setContent] = useState(DEFAULT_CONTENT[key] || {});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await fetch(`${BACKEND_URL}/api/site-content/${key}`);
        if (response.ok) {
          const data = await response.json();
          if (data.content) {
            setContent(data.content);
          }
        }
      } catch (error) {
        console.error(`Error fetching ${key} content:`, error);
        // Keep default content on error
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, [key]);

  return { content, loading };
};

export default useSiteContent;
